import { PWUtils } from './../../shared';
import { Type } from 'class-transformer';

export enum TenantStatus {
  Active = 'Active', Inactive = 'Inactive'
}

export class Tenant {
  id: string;
  name: string;
  status: TenantStatus;
  @Type(PWUtils.classType(Date))
  createdAt: Date;

  get isActive(): boolean {
    return this.status === TenantStatus.Active;
  }
}
